import React from "react";

const CertificateSettingsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.606"
      height="50.032"
      viewBox="0 0 34.606 50.032"
    >
      <path
        id="db55"
        d="M310.822,233.93H279.635a1.673,1.673,0,0,0-1.668,1.668v39.108a1.673,1.673,0,0,0,1.668,1.668h4.5v-4.5a10.56,10.56,0,0,1-2.085-6.171,10.34,10.34,0,1,1,20.679,0,10.016,10.016,0,0,1-2.085,6.171v4.5H310.9a1.673,1.673,0,0,0,1.668-1.668V235.6a1.806,1.806,0,0,0-1.751-1.668Zm-7.505,12.759H287.14a1.668,1.668,0,0,1,0-3.336h16.094a1.673,1.673,0,0,1,1.668,1.668,1.6,1.6,0,0,1-1.585,1.668ZM292.31,275.958a10.411,10.411,0,0,0,5.753-1.751v8.255a1.486,1.486,0,0,1-.834,1.334,1.206,1.206,0,0,1-.584.166,1.254,1.254,0,0,1-.918-.334l-3.419-2.752-3.419,2.752a1.4,1.4,0,0,1-1.5.166,1.486,1.486,0,0,1-.834-1.334v-8.255a9.968,9.968,0,0,0,5.754,1.752Zm7.838-10.256a7.838,7.838,0,1,1-7.838-7.838A7.829,7.829,0,0,1,300.148,265.7Z"
        transform="translate(-277.967 -233.93)"
        fill={fill ? fill : "#ff7eb5"}
      />
    </svg>
  );
};

export default CertificateSettingsIcon;
